module.exports = __webpack_public_path__ + "static/media/export-teel.13ec21ff.svg";